import React from 'react'
import Layout from '../../components/help/Layout/Layout'
import Seo from '../../components/help/Seo'
import Header from '../../components/ui/Header/Header'
import Intro from '../../components/ui/Intro/Intro'
import { getHrefToHome } from '../../utils/getHrefToHome'
import { graphql, useStaticQuery } from 'gatsby'
import Job from '../../components/pages/Team/Job/Job'
import Directors from '../../components/pages/Team/Directors/Directors'
import TopManagement from '../../components/pages/Team/TopManagement/TopManagement'
import Videos from '../../components/pages/Team/Videos/Videos'
import { useDataVideos } from '../../components/pages/Team/Videos/useDataVideos'

const TeamPage = () => {
    const lang = 'hy'

    const hrefHome = getHrefToHome(lang)
    const videos = useDataVideos()

    const data = useStaticQuery(graphql`
        {
            title: datoCmsRenshinPageTeam(title: { eq: "Title" }, locale: { eq: "hy" }) {
                value
            }

            text: datoCmsRenshinPageTeam(title: { eq: "Text" }, locale: { eq: "hy" }) {
                value
            }

            titleSmall: datoCmsRenshinPageTeam(title: { eq: "Title small" }, locale: { eq: "hy" }) {
                value
            }

            boardOfDirectors: datoCmsRenshinPageTeam(title: { eq: "The Board of Directors" }, locale: { eq: "hy" }) {
                value
            }

            topManagement: datoCmsRenshinPageTeam(title: { eq: "Top Management" }, locale: { eq: "hy" }) {
                value
            }

            videosTitle: datoCmsRenshinPageTeam(title: { eq: "Block 3: Title" }, locale: { eq: "hy" }) {
                value
            }

            jobTitle: datoCmsRenshinPageTeam(title: { eq: "Block 2: Title" }, locale: { eq: "hy" }) {
                value
            }

            jobText: datoCmsRenshinPageTeam(title: { eq: "Block 2: Text" }, locale: { eq: "hy" }) {
                value
            }

            jobEmail: datoCmsRenshinPageTeam(title: { eq: "Block 2: E-mail" }, locale: { eq: "hy" }) {
                value
            }

            applyNow: datoCmsRenshinPageTeam(title: { eq: "Email Button Text" }, locale: { eq: "hy" }) {
                value
            }

            jobImage: datoCmsRenshinPageTeam(title: { eq: "Block 2: Image" }, locale: { eq: "hy" }) {
                image {
                    url
                }
            }

            photo: datoCmsRenshinPageTeam(title: { eq: "Photo" }, locale: { eq: "hy" }) {
                photoDesktop {
                    url
                }
                photoTabletA {
                    url
                }

                photoTabletP {
                    url
                }

                photoMobile {
                    url
                }
            }

            slides: allDatoCmsRenshinTeam(sort: { fields: sorting, order: ASC }, filter: { locale: { eq: "hy" } }) {
                nodes {
                    name
                    quote
                    positions
                    photo {
                        url
                    }
                    category
                }
            }

            seo: datoCmsRenshinSeo(originalId: { eq: "114097359" }, locale: { eq: "hy" }) {
                titleH1
                crumbsName
                bgDesktop {
                    url
                }
                bgTabletA {
                    url
                }
                bgTabletP {
                    url
                }

                bgMobile {
                    url
                }
                footerLinks {
                    title
                    url
                }
                seo {
                    title
                    description
                }
            }

            main: datoCmsRenshinSeo(originalId: { eq: "114097337" }, locale: { eq: "hy" }) {
                crumbsName
            }
        }
    `)

    const breadCrumbs = [
        { name: `${data.main.crumbsName}`, href: `${hrefHome}`, current: false },
        { name: `${data.seo.crumbsName}`, current: true }
    ]

    const photo = {
        1920: data.seo.bgDesktop.url,
        1440: data.seo.bgDesktop.url,
        1024: data.seo.bgTabletA?.url,
        768: data.seo.bgTabletP?.url,
        360: data.seo.bgMobile?.url
    }

    return (
        <Layout lang={lang}>
            <Seo title={data.seo?.seo?.title} description={data.seo?.seo?.description} />
            <Header light lang={lang} />
            <Intro crumbs={breadCrumbs} title={data.seo.titleH1} photo={photo} lang={lang} />
            <Directors data={data} lang={lang} />
            <TopManagement data={data} lang={lang} />
            <Job data={data} lang={lang} />
            <Videos items={videos} title={data.videosTitle?.value} lang={lang} />
        </Layout>
    )
}

export default TeamPage
